import React from 'react';
import { formatMoney } from '../../helpers/formatters';

export const OrderChildRowItem = ({ item }) => {
    const useItemPrice = true;
    const computeTotal = () => {
        const price = Number(useItemPrice ? item.price : item.product.price);
        const quantity = Number(item.quantity);
        return price * quantity;
    };

    return (
        <li className="list-group-item bg-light">
            <div className="row">
                <div className="icon-cell col-lg-1 col-xl-1">
                    <p className="text-center text-secondary mt-3 mt-lg-0">
                        <i className={`fad fa-${item.product.icon} fa-2x`}></i>
                    </p>
                </div>
                <div className="name-cell col-lg-3 col-xl-4 d-flex justify-content-between">
                    <label className="d-block d-lg-none fw-bold my-2">Name</label>
                    <p className="my-1">{item.product.name}</p>
                </div>
                <div className="price-cell col-lg-3 col-xl-2 d-flex justify-content-between">
                    <label className="d-block d-lg-none fw-bold my-2">Price</label>
                    <p className="text-end w-100 my-1">{formatMoney(item.price)}</p>
                </div>
                <div className="quantity-cell col-lg-2 col-xl-2 d-flex justify-content-between">
                    <label className="d-block d-lg-none fw-bold my-2">Quantity</label>
                    <p className="text-end w-100 my-1">{item.quantity}</p>
                </div>
                <div className="total-cell col-lg-3 col-xl-3 d-flex justify-content-between">
                    <label className="d-block d-lg-none fw-bold my-2">Total</label>
                    <p className="text-end w-100 my-1">{formatMoney(computeTotal())}</p>
                </div>
            </div>
        </li>
    );
};
